export class Version {
  code: string;
  commercialCode: string;
  name: string;
  slug: string;
  price: number;
}
